import { RENTAL_PORTAL_LISTING_STATUS } from '../../../../constants/rentalPortal'

export const QA_NAME_LISTING_BOARD = 'listingBoard'

export const QA_NAME_LISTING_BOARD_CARD = 'listingBoardCard'

export const QA_NAME_LISTING_BOARD_CARD_ACTIONS = 'listingBoardCardActions'

export const QA_NAME_LISTING_BOARD_CARD_SELECT = 'listingBoardCardSelect'

export const QA_NAME_LISTING_BOARD_COLUMN_SELECT = 'listingBoardColumnSelect'

export const QA_NAME_LISTING_BOARD_MORE = 'listingBoardMore'

export const QA_NAME_LISTING_BOARD_SKELETON_CARD = 'listingBoardSkeletonCard'

export const LISTING_BOARD_SKELETON_CARDS = ['first', 'second']

export const LISTING_BOARD_COLUMN_ORDER = [
  RENTAL_PORTAL_LISTING_STATUS.draft,
  RENTAL_PORTAL_LISTING_STATUS.published,
  RENTAL_PORTAL_LISTING_STATUS.closed,
  RENTAL_PORTAL_LISTING_STATUS.deactivated,
]

export const LISTING_BOARD_COLUMN_CAP = 25
